import { useQuery } from '@tanstack/react-query';

import { api } from 'constants/api';
import { ApiResponse } from 'types/utils/api-response';
import { BusinessStatsType } from './useGetBusinessStats';

type GetAggregatedAnalyticsParams = {
  channel: string;
};

export const useGetAggregatedAnalytics = ({
  channel,
}: GetAggregatedAnalyticsParams) => {
  return useQuery({
    queryKey: ['getAggregatedAnalytics', channel],
    enabled: true,
    queryFn: async () => {
      const { data } = await api.get<ApiResponse<BusinessStatsType>>(
        `business/aggregate-analytics?channel=${channel}`
      );

      return data?.data;
    },
  });
};
